export const headersPlanoEntrega = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 4, key: 'statusCotacao' },
  { text: 'Destino', width: 3, key: 'numeracaoReq' },
  { text: 'Data Prevista', width: 10, key: 'dataPrevista' },
  { text: 'Data Últ. Entrega', width: 7, key: 'dataUltEntrega' },
  { text: 'Qtd Prevista', width: 8, key: 'qtdPrevista' },
  { text: 'Qtd Entregue', width: 7, key: 'qtdEntregue' },
  { text: '% Entregue', width: 10, key: 'percEntregue' },
];

export const dataPlanoEntrega = [
  {
    id: 1,
    statusCotacao: 'Em andamento',
    numeracaoReq: 'REQ-001/2025',
    dataPrevista: '2025-11-05',
    dataUltEntrega: '2025-10-10',
    qtdPrevista: 1200,
    qtdEntregue: 800,
    percEntregue: '66,7%',
  },
  {
    id: 2,
    statusCotacao: 'Concluído',
    numeracaoReq: 'REQ-002/2025',
    dataPrevista: '2025-10-15',
    dataUltEntrega: '2025-10-14',
    qtdPrevista: 500,
    qtdEntregue: 500,
    percEntregue: '100%',
  },
  {
    id: 3,
    statusCotacao: 'Atrasado',
    numeracaoReq: 'REQ-003/2025',
    dataPrevista: '2025-10-10',
    dataUltEntrega: '—',
    qtdPrevista: 750,
    qtdEntregue: 0,
    percEntregue: '0%',
  },
  {
    id: 4,
    statusCotacao: 'Parcialmente entregue',
    numeracaoReq: 'REQ-004/2025',
    dataPrevista: '2025-11-20',
    dataUltEntrega: '2025-10-18',
    qtdPrevista: 2000,
    qtdEntregue: 1200,
    percEntregue: '60%',
  },
  {
    id: 5,
    statusCotacao: 'Cancelado',
    numeracaoReq: 'REQ-005/2025',
    dataPrevista: '2025-11-10',
    dataUltEntrega: '—',
    qtdPrevista: 300,
    qtdEntregue: 0,
    percEntregue: '0%',
  },
];

export const valoresExibidosPlanoEntrega: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Cotação
  statusCotacao: 'Status da Cotação',
  numeracaoReq: 'Nº da REQ',
  produtoDAF: 'Produto Farmacêutico',
  valorUnitario: 'Valor Unitário US$',
  cotacaoDolar: 'Cotação do Dólar',
  dataCotacao: 'Data da Cotação',
  qtdCotada: 'Qtd Cotada',
  valorTotal: 'Valor Total R$',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorCotacao: '',
};

export const fieldObjectPlanoEntrega = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
